'use strict';

angular.module('2FaAuth')

.controller('2FaAuthCtrl', function ($rootScope, $uibModal, $http, $uibModalInstance, kdAuth, appConfig) {

    this.config = appConfig.twoFa;

    this.data = {
        active: kdAuth.user.two_fa_enabled,
    };

    this.onChange = () =>
    {
        if (this.data.active) {

            $uibModal.open({
                templateUrl: '2fa-auth/2FaAuthSetup.html',
                controller: '2FaAuthSetupCtrl',
                controllerAs: '$ctrl',
                bindToController: true,
                backdrop: true,
                resolve: {
                    data: () => {
                        return $http.get('api/two-fa/generate').then((response) => {
                            return response.data;
                        });
                    }
                }
            });

        } else {

            $uibModal.open({
                templateUrl: '2fa-auth/2FaAuthDisable.html',
                controller: '2FaAuthDisableCtrl',
                controllerAs: '$ctrl',
                bindToController: true,
            });
        }

        $uibModalInstance.close();
    };

});
